import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewFeatureAlertComponent } from './new-feature-alert.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    declarations: [NewFeatureAlertComponent],
    imports: [CommonModule, MatIconModule],
    exports: [NewFeatureAlertComponent]
})
export class NewFeatureAlertModule { }